import { render, staticRenderFns } from "./OrdersLegend.vue?vue&type=template&id=a991c210&"
import script from "./OrdersLegend.vue?vue&type=script&lang=js&"
export * from "./OrdersLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports